import { iRecordType } from "./iRecordType";

export class FillValue implements iRecordType
{
    public id:string;
    public value_type:number;
    public item_label:string;
    public item_value:string;

    public static apiName:string = "FillValue";

    get className():string 
    {
        return this.className;
    }

    constructor(values: Object = {}) {          
        Object.assign(this, values);          
    }
}


// WEBPACK FOOTER //
// I:/Yog/Projects/Web/LetterDev/wwwroot/ManagerApp/wwwroot/src/app/model/fillvalue.ts